
import search from '~/components/header/Search';
import searchSections from '~/constants/search-sections.json';

let timeOutChangeSearch = '';
export default {
  name: 'PopUpSearch',

  data: function () {
    return {
      sections: [],

      search: '',
      activeSection: '',

      isLoading: false,
    };
  },

  computed: {
    isOpen: function () {
      return Boolean(this.$store.state.search?.isOpen);
    },
  },

  components: {
    SectionPages: () => import('~/components/search/SectionPages'),
    SectionProducts: () => import('~/components/search/SectionProducts'),
  },

  watch: {
    search: function () {
      clearTimeout(timeOutChangeSearch);
      this.isLoading = true;
      timeOutChangeSearch = setTimeout(async () => {
        await this.getSearch();
      }, 1000);
    },
    $route: function () {
      this.closeSearch();
    },

    isOpen: function () {
      if (this.isOpen) {
        document.body.style.overflow = 'hidden';
        setTimeout(() => {
          this.inputFocus();
        }, 500);
      } else {
        document.body.style = '';
      }
    },
  },

  methods: {
    closeSearch: function () {
      this.$store.commit('search/setOpen', false);
    },

    getSearch: async function () {
      if (this.search.length <= 0) {
        this.isLoading = false;
        this.resetSearch();
        return;
      }

      const response = await this.$api.agent.transport.get(`/catalog/search?query=${this.search}&expand=short_characteristics`).then((res) => res.data).catch((err) => ({}));

      const results = response?.results || {};
      results.products_used = {
        name: 'Б/У товары',
        text: 'description',
        title: 'name',
        total: (results?.products?.items || []).filter((t) => [12, 13].includes(t.characteristic_group_id)).length,
        description: 'short_description',
        items: (results?.products?.items || []).filter((t) => [12, 13].includes(t.characteristic_group_id)),
      };
      results.products = {
        ...results.products,
        items: (results?.products?.items || []).filter((t) => ![12, 13].includes(t.characteristic_group_id)),
      };

      let sections = [];
      Object.keys(results).map((key) => {
        const section = results[key];
        const sectionKey = Object.keys(searchSections).find((keySection) => searchSections[keySection].find((t) => t === key));

        sections.push({
          sectionName: key,
          sectionKey: sectionKey,
          ...section,
        });
      });
      sections = sections.filter((t) => t.total > 0);

      this.sections = sections;
      this.isLoading = false;
    },
    resetSearch: function () {
      this.search = '';
      this.sections = [];
    },

    changeActiveSection: function (activeSection) {
      this.activeSection = activeSection;
    },

    _visibledSection: function (section, componentName) {
      const { sectionName } = section;

      if (this.activeSection) {
        return Boolean(this.activeSection === sectionName);
      }

      return true;
    },

    inputFocus: function () {
      if (!this.$refs.refInputSearch) {
        return;
      }
      this.$refs.refInputSearch.focus();
    },

    goPageSearch: function () {
      if (!this.search || this.search.length < 2) {
        return;
      }

      this.$router.push(`/search?search=${this.search}`);
    },
  },
};
